module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker87-api.relevant-digital.com/"}};